import { IsProduction } from "../Environment/Environment";

export type SavedPasteFileResponse = {
    fileName: string;
    filePath: string;
    publicUrl: string;
    byteLength: number;
    mimeType: string;
};

type UploadPayload = {
    dataUrl: string;
    originalName?: string;
};

export async function UploadPastedFileAsync(
    payload: UploadPayload
): Promise<SavedPasteFileResponse> {
    const response = await fetch(
        GetLogicServerBaseURL() + "system/devtools/paste-file",
        {
            method: "POST",
            mode: "cors",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        }
    );

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
            `File upload failed: ${response.status} ${response.statusText} - ${errorText}`
        );
    }

    const data = (await response.json()) as SavedPasteFileResponse | undefined;

    if (!data) {
        throw new Error("File upload failed: server returned no data.");
    }

    return data;
}

function GetLogicServerBaseURL() {
    if (!IsProduction()) {
        return `${location.origin}/`;
    }

    return process.env.LOGIC_SERVER_URL!;
}
